<div class="breadcrumb">
    <app-breadcrumb
            [firstNode]="{label: 'Users list', 'url': '/home'}">
    </app-breadcrumb>
</div>

<div class="card card--box notification-header">
    <div class="card--box__header">
        <div class="card--box__header--info">
            <div class="card--box__header__title help-btn">
                {{ 'Notifications' | translate }}
                <app-popover [templateType]="helpTemplateName"
                             fontSize="60%"
                             iconClass="popover-icon--white ml-1"
                             containerClass="notification-help"
                             [isFlex]="true"
                             placement="bottom">
                </app-popover>
            </div>
        </div>
        <div *ngIf="this.appService.notifications.length" class="right-section">
            <div class="btn-group dropdown" dropdown>
                <button dropdownToggle type="button" class="btn btn-primary dropdown-toggle dropdown-toggle--inactive">
                    {{ 'All notifications' | translate }}
                    <span class="caret"></span>
                </button>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                    <li role="menuitem">
                        <div class="dropdown-item" (click)="makeReadAll()">
                            <i class="far fa-envelope-open" aria-hidden="true"></i>
                            <span>
                                <div class="dropdown-item__description">{{ 'Mark all notifications as read' | translate }}</div>
                            </span>
                        </div>
                    </li>
                    <li class="divider dropdown-divider"></li>
                    <li role="menuitem">
                        <a class="dropdown-item"  (click)="makeUnreadAll()">
                            <i class="far fa-envelope" aria-hidden="true"></i>
                            <span>
                                <div class="dropdown-item__description">{{ 'Mark all notifications as unread' | translate }}</div>
                            </span>
                        </a>
                    </li>
                    <li class="divider dropdown-divider"></li>
                    <li role="menuitem">
                        <div class="dropdown-item" (click)="deleteAll()">
                            <i class="far fa-trash-alt" aria-hidden="true"></i>
                            <span>
                                <div class="dropdown-item__description">{{ 'Delete all notifications' | translate }}</div>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div *ngIf="this.appService.notificationLoaded" class="row">
    <div *ngIf="!this.appService.notifications.length; else hasNotifications" class="col-xs-12">
        <div class="box-shadow">
            <div class="notification-item--loading">
                {{ 'You have no notifications at the moment. Have a nice day!' | translate }}
            </div>
        </div>
    </div>
    <ng-template #hasNotifications>
        <div class="col-xs-4">
            <div class="box-shadow notification-list">
                <div class="notification-list__header">
                    <ng-template ngFor let-i="index" let-notificationItem
                                 [ngForOf]="this.appService.notifications | slice : ((currentPage-1)*itemsPerPage):(currentPage*itemsPerPage)">
                        <notification-item [notificationItem]="notificationItem"
                                           [selectedNotificationId]="selectedNotification?.id"
                                           (notificationClicked)="onClickNotification($event)"
                                           [ngClass]="{'selected-out': notificationParamId === notificationItem?.id}"></notification-item>
                    </ng-template>
                </div>
                <div class="notification-list__footer">
                    <pagination-component [(page)]="currentPage" [total]="this.appService.notifications.length" *ngIf="paginationDisplay" [perPage]="itemsPerPage"
                                          [limit]="1" [isSmallPadding]="true" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginateNotification($event, false)"
                                          #pagination>
                    </pagination-component>
                </div>
            </div>
        </div>
        <div class="col-xs-8">
            <div class="box-shadow">
                <app-notifications-details [selectedNotification]="selectedNotification"></app-notifications-details>
            </div>
        </div>
    </ng-template>
</div>
<div *ngIf="!this.appService.notificationLoaded" class="box-shadow">
    <div class="notification-item--loading">
        {{ 'Loading' | translate }}...
    </div>
</div>
<dialog-component #dialog></dialog-component>
